<div style="text-align: center">
    <span class="textoSuperior">{{ this.nombreTextoPrincipal }}<br/>
    </span>
    <span class="textoInferior">{{ this.textoInferior }}</span>
</div>


